import lodash from 'lodash';

import { Season } from 'types';

export const mapSeasons = (seasons: Season[]) => {
  const seasonsSorted = lodash.groupBy(seasons, 'season');

  const seasonsIntoObjects = Object.entries(seasonsSorted).map(([key, value]) => ({
    season: key,
    catalog: value.map((item) => item.descEng),
  }));

  return seasonsIntoObjects;
};

export const sortSeasons = (seasons: Season[]) =>
  seasons.sort((a, b) => +b.timestamp - +a.timestamp);
